import React, { useState } from "react";

function LocationFinder() {
  const [location, setLocation] = useState(null);
  const [status, setStatus] = useState("");

  const [full_address, setFullAddress] = useState(null);

  const getLocation = () => {
    setStatus("Getting coordinates...");
    if (!navigator.geolocation) {
      setStatus("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        fetchAddress(latitude, longitude);
      },
      (error) => {
        console.error("Geolocation error:", error);
        setStatus("Unable to get location. Please allow location access.");
      }
    );
  };

  const fetchAddress = async (latitude, longitude) => {
    setStatus("Fetching address...");
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
      );
      const data = await response.json();
      console.log(data.display_name);

      if (data?.address) {
        setLocation({
          latitude,
          longitude,
          city:
            data.address.city ||
            data.address.town ||
            data.address.village ||
            "Not available",
          state: data.address.state || "Not available",
          country: data.address.country || "Not available",
          zipcode: data.address.postcode || "Not available",
        });
        setFullAddress(data.display_name);
        setStatus("");
      } else {
        setStatus("No address found for these coordinates.");
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setStatus("Failed to fetch the address.");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "sans-serif",
        flexDirection: "column",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <button
        onClick={getLocation}
        disabled={status.includes("Getting") || status.includes("Fetching")}
        style={{
          display: "inline-block",
          marginTop: "15px",
          padding: "10px 15px",
          backgroundColor: "#007bff",
          color: "white",
          borderRadius: "5px",
          textDecoration: "none",
        }}
      >
        Find My Location
      </button>

      {status && <p style={{ marginTop: "15px", color: "gray" }}>{status}</p>}

      {location && (
        <div style={{ marginTop: "25px", lineHeight: "1.6" }}>
          <h3>Your Location:</h3>
          <p>
            <strong>Latitude:</strong> {location.latitude}
            <br />
            <strong>Longitude:</strong> {location.longitude}
            <br />
            <strong>City:</strong> {location.city}
            <br />
            <strong>State:</strong> {location.state}
            <br />
            <strong>Country:</strong> {location.country}
            <br />
            <strong>ZIP Code:</strong> {location.zipcode}
            <br />
            <strong>Full address</strong> {full_address}
          </p>
          <a
            href={`https://www.google.com/maps?q=${location.latitude},${location.longitude}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              marginTop: "15px",
              padding: "10px 15px",
              backgroundColor: "#007bff",
              color: "white",
              borderRadius: "5px",
              textDecoration: "none",
            }}
          >
            Open in Google Maps
          </a>
        </div>
      )}
    </div>
  );
}

export default LocationFinder;
